<template>
  <div class="row">

    <div class="col-12">

      <h4 class="stage-results__title">{{'report.table_prompts' | trans }}</h4>
      <table-view
          v-if="showReport"
          :options="optionsStatisticList"
          :isChange="isChangeStatic"
          :isList=isMobile
          class="stimulus_table"
      >


        <div slot="motivationCondition" slot-scope="props" class="nowrap">
          <div v-if="props.row.motivationCondition">{{'admin.yes' | trans }}</div>
          <div v-if="!props.row.motivationCondition">{{'admin.no' | trans }}</div>
        </div>

        <div slot="action" slot-scope="props">
          <div v-if="props.row.name">
            <mdc-checkbox
                :checked="checkedStimulus(props.row.id)"
                @change="choseSimpleStimulus(props.row, $event)"
                :disabled="chosenStimul.length == 4 && !checkedStimulus(props.row.id)"
                name="mandReaction"/>
          </div>
        </div>

      </table-view>

      <div class="col-12 text-right">
        <button type="button"
                class="btn btn-primary mt-3 mt-sm-0 mb-2 mb-sm-0" raised
                @click.prevent="chartSimpleShow()">
          {{'report.show_graph_btn' | trans}}
        </button>
      </div>

      <div v-for="stage in stagesList" class="row"  v-if="(!selectedStage || (selectedStage && selectedStage.id == stage.id)) && chosenStimul.length && showReport">
        <current-stage-simple :protocol-id="protocolId" :chosenStimul="chosenStimul"  :is-apply-filter="showSimpleReport" :stage="stage" :rangeDateStartTimestamp="rangeDateStartTimestamp" :rangeDateEndTimestamp="rangeDateEndTimestamp"></current-stage-simple>
      </div>

    </div>

  </div>

</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineNonNumericYChart, LineChartDataset, LineChart} from '../../../common/chart';
  import filter from 'lodash/filter';
  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopup';
  import PromptChart from '../../chart/component/PromptChart';
  import CurrentStageSimple from './CurrentStageSimple';
  
  export default {
    props: ['selectedStage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'stagesList', 'showReport'],
    components: {
      TableView, LineChart, LineChartDataset, LineNonNumericYChart, Loader, ChartPopup, PromptChart, CurrentStageSimple
    },

    data() {
      return {
        isChangeStatic: false,
        showSimpleReport: true,
        apiUrl: '/protocols/assigned/',
        chosenStimul: [],
        optionsStatisticList: {
          initialPage: null,
          perPage: 10,
          pagination: {
            chunk: 20,
          },
          filterable: false,
          debounce: 1000,
          sortable: [],
          withSearch: false,
          skin: 'table table-sm',
          columns: [
            {
              key: 'name',
              changed: false,
              headings: lang.get('protocol.name_mand_reaction')
            },
            {
              key: 'stage',
              changed: false,
              headings: lang.get('protocol.stage')
            },
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('protocol.started_at')
            },
            {
              key: 'masteredAt',
              changed: false,
              headings: lang.get('protocol.date_mastering')
            },
            {
              key: 'countSamples',
              changed: false,
              headings: lang.get('protocol.countSamples')
            },
            {
              key: 'action',
              changed: true,
              headings: lang.get('protocol.choose_stimul_chart')
            }
          ],
          templates: {
            masteredAt: this.masteredAt,
            startedAt: this.startedAt,
          },
          listRow: {
            name: {
              headings: lang.get('protocol.name_mand_reaction'),
              hasTemplate: false,
            },
            stage: {
              headings: lang.get('protocol.stage'),
              hasTemplate: false,
            },
            startedAt: {
              headings: lang.get('protocol.started_at'),
              hasTemplate: true,
            },
            masteredAt: {
              headings: lang.get('protocol.date_mastering'),
              hasTemplate: true,
            },
            countSamples: {
              headings: lang.get('protocol.countSamples'),
              hasTemplate: false,
            },
          },
          requestFunction: this.requestStimulListFunction,
          responseAdapter: function (resp) {
            return {
              data: resp.data.data.items,
              count: resp.data.data.total
            }
          },
          texts: {
            filter: "",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
            count: "Страница {page} из {pages}",
          },
          columnsClasses: {
            answerTitle: 'text-center',
            mandLevel: 'text-center',
            motivationCondition: 'text-center',
            countSamples: 'text-center',
          },
          rowClassCallback(row) {
            return row.checked ? "table-info" : "";
          }
        },
      };
    },

    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),
      
    },

    async created() {
      //this.chartShow();
    },

    methods: {

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      async requestStimulListFunction (data) {
        this.isChangeStatic = false;
        localStorage.setItem('currentPage', data.page);
        localStorage.setItem('currentPageHeader', 'pecsWithDescrimination');
        return this.onSendReactionListRequest(this.optionsStatisticList.perPage, data.page);
      },

      onSendReactionListRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-reactions-statistics/';
        let params = {
          perPage: perPage,
          page: page,
          stageId: this.selectedStage ? this.selectedStage.id : null,
          startDate: this.rangeDateStartTimestamp,
          endDate: this.rangeDateEndTimestamp,
        };
        let response = await axios.get(url, {params: params});
        this.list = response.data.data.items;
        return response;
      },

      checkedStimulus(id) {
        let checked = false;
        if (id && this.chosenStimul.length) {
          forEach(this.chosenStimul, stimul => {
            if (stimul.stimulusId == id || stimul.id == id) {
              checked = true;
            }
          })
        }

        return checked
      },

      choseSimpleStimulus(val, checked) {
        this.isChangeStimuli = true;
        this.showSimpleReport = false;
        if (checked) {
          this.chosenStimul.push(val);

        } else {
          let array = filter(this.chosenStimul, item => {
            return item.name !== val.name
          });
          this.chosenStimul = array;
        }

      },

      async chartSimpleShow(){

        this.showSimpleReport = true;

        this.loaded = true;
      },
      
    },

    watch:{
      showReport(newValue){

        if(!newValue){
          this.chosenStimul = [];
          this.isChangeStatic = true;
        }
      }
    }


  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentSimple.vue